import './CarDetails.scss';
import { useEffect, useState } from 'react';
import Button from '../../../components/Button/Button';
import CarPreview from '../../../components/CarPreview/CarPreview';

import MsrpDisclaimer from '../../../components/MsrpDisclaimer/MsrpDisclaimer';
import CarSpecs from '../../../components/CarSpecs/CarSpecs';
import { formatPrice, isMobile, isTablet } from '../../../services/shared';
import CarOffer from '../../../components/CarOffer/CarOffer';
import CarName from '../../../components/CarName/CarName';

const CarDetails = ({make, model, year, car, masterCarList, modelOptions, yearOptions, trimOptions, ctaClicked, handleMakeModelChange, showCarousel, hideCTA= false, showMoreDetails = false})=>{
    const [editModel, setEditModel] = useState(false);
    return (<>
        <div className="car-details-wrapper">
            <CarPreview 
                make={make}
                model={model}
                year={year}
                car={car}
                masterCarList={masterCarList} 
                modelOptions={modelOptions} 
                yearOptions={yearOptions}
                editModel={editModel}
                showCarousel={showCarousel}>
            </CarPreview>
            {
                isMobile() || isTablet() ? <CarName 
                    make={make} 
                    model={model} 
                    year={year} 
                    masterCarList={masterCarList} 
                    modelOptions={modelOptions} 
                    yearOptions={yearOptions} 
                    trimOptions={trimOptions} 
                    editModel={editModel} 
                    openEdit={()=>{
                        setEditModel(true)
                    }} 
                    cancelEdit={()=>{
                        setEditModel(false)
                    }} 
                    carChanged={(make,model,year,car)=>{
                        setEditModel(false);
                        handleMakeModelChange(make,model,year,car)
                    }}
                ></CarName>:null
            }
            {
                isMobile() || isTablet() ? <CarOffer car={car} make={make}></CarOffer>: null
            }

            <div className="car-specs-wrapper">
                { car && <CarSpecs car={car} showMoreDetails={showMoreDetails}></CarSpecs> }
            </div>
            
            {
                car?.keyFeatures?.length > 0 &&
                <div className="key-highlights">
                    <div className="key-highlights--header">Key Highlights</div>
                    <ul className="key-highlights--list">
                        {
                            car.keyFeatures.map(_=>(<li key={_}>{_}</li>))
                        }
                    </ul>
                </div>
            }
            

            <MsrpDisclaimer></MsrpDisclaimer>
            
            {
                !hideCTA && 
                <div className="field extra-top flex sticky">
                    <Button className="xl primary" type="submit" onClick={()=>{
                        ctaClicked()
                    }}>Continue</Button>
                </div>
            }
            
        </div>
    </>)
}

export default CarDetails;